import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page22() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let translate = {
        0: "خیلی کم",
        1: "کم",
        2: "متوسط",
        3: "زیاد",
        4: "خیلی زیاد",
    }
    let hooshChandgane;
    if (JSON.parse(localStorage?.data)?.[jobId]?.hooshChandgane) {
        hooshChandgane = JSON.parse(localStorage?.data)?.[jobId]?.hooshChandgane
    } else {
        hooshChandgane = []
    }
    // console.log(hooshChandgane);
    return (
        <Page pageNumber={22}>
            <div className="font-bold text-lg">
                هوش‌های چندگانه
            </div>
            <p className="text-black text-justify">
                هوش‌های چندگانه به انواع مختلف توانایی‌های شناختی و رفتاری اشاره دارند که افراد در انجام وظایف شغلی از آن‌ها بهره می‌گیرند. این هوش‌ها شامل هوش زبانی، منطقی-ریاضی، فضایی، موسیقایی، بدنی-حرکتی، میان‌فردی، درون‌فردی و طبیعت‌گرا هستند. تحلیل نوع و سطح هوش‌های مورد نیاز، به انتخاب شایسته، طراحی آموزش‌های هدفمند و ارتقاء عملکرد کمک می‌کند. درج این بخش، درک عمیق‌تری از تناسب فرد با الزامات شغلی فراهم می‌سازد.
            </p>
            {
                hooshChandgane && Object.keys(hooshChandgane)[0]
                    ?
                    <>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/conversation.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[0]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[0].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[0].value]}</div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/math.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[1]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[1].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[1].value]}</div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/location.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[2]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[2].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[2].value]}</div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/jogging.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[3]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[3].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[3].value]}</div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/networking.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[4]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[4].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[4].value]}</div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/self-awareness.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[5]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[5].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[5].value]}</div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center justify-center gap-3 odd-color">
                                <div className="flex justify-center w-[100px] bg-gray-200 p-2 rounded">
                                    <img src="./assets/img/tone.png" className="w-[60px]" />
                                </div>
                                <div className="w-full flex flex-col gap-1 border-x-2 px-2">
                                    <div>
                                        {Object.keys(hooshChandgane)[6]}
                                    </div>
                                    <p className="text-sm">
                                        {Object.values(hooshChandgane)[6].desc}
                                    </p>
                                </div>
                                <div className="text-[13px] font-bold w-[150px] flex justify-center">{translate[Object.values(hooshChandgane)[6].value]}</div>
                            </div>
                        </div>
                    </>
                    :
                    null
            }
            <p className="rounded-lg p-4 text-justify">
                در این شغل برخورداری از ‌
                <span className="text-gray-800">
                    {hooshChandgane &&
                        Object.keys(hooshChandgane).sort(function (a, b) { return hooshChandgane[b].value - hooshChandgane[a].value }).map((key, index) => {
                            if (index < 3) {
                                return (key) + "، "
                            }
                        })}
                </span>
                به نسبت بقیه انواع هوش‌ها از اهمیت بالاتری برخوردار است و افرادی مناسب این شغل هستند که توانایی بالایی در این زمینه‌ها دارند.
            </p>
        </Page>
    )
}